/**
 * Qual item da sidebar está ativo.
 *
 * A regra anterior era `location.pathname.includes(route.path)` — substring crua. Ela acende
 * **qualquer** item cujo caminho seja pedaço da URL atual: em `/admin/profiles`, o item `profile`
 * ("Perfil") acende junto de "Perfis de acesso", porque `"profiles".includes("profile")`.
 *
 * O problema não é o par específico; é o método. Toda rota nova cujo caminho seja prefixo de outra
 * reintroduz o bug em silêncio — e a colisão só aparece para quem visita as duas telas.
 *
 * A comparação passa a ser por **segmento**: igualdade exata, ou a URL descendo para uma subrota
 * (`/admin/project-tasks/42` mantém "Tarefas" aceso).
 */
export function isRouteActive(pathname: string, layout: string, path: string): boolean {
  const strip = (s: string) => s.replace(/\/+$/, "");
  const current = strip(pathname);
  const target = strip(`${layout}/${path}`);
  return current === target || current.startsWith(`${target}/`);
}
